import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Article } from '../models/knowledge-base';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeBaseService {
  constructor(
    private http: HttpClient,
    @Inject('env') private env: any,
    @Inject('errorInterceptorSkipHeader') private errorInterceptorSkipHeader: any
  ) {}

  private _kbUrl = `${this.env.apiUrlRoot}/KnowledgeBase`;

  // #region Public Methods

  public getArticlesInFolder(folderId: number): Observable<Article[]> {
    let headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');

    return this.http
      .get<Article[]>(`${this._kbUrl}/Folder/${folderId}/Articles`, { headers })
      .pipe(map(results => results?.sort(this._sortByDateDescending) ?? []));
  }

  public getArticlesReadByUser(): Observable<number[]> {
    let headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');

    return this.http.get<number[]>(`${this._kbUrl}/ArticlesRead`, { headers });
  }

  public markArticleRead(articleId: number): Observable<void> {
    let headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');

    return this.http.post<void>(`${this._kbUrl}/MarkArticleRead/${articleId}`, { headers });
  }

  // #endregion

  // #region Private Methods
  private _sortByDateDescending(a: Article, b: Article): number {
    if (a.SynthDate > b.SynthDate) return -1;
    if (a.SynthDate < b.SynthDate) return 1;
    return 0;
  }
  // #endregion
}
